<div class="form-group">
  <div [ngSwitch]="facet.facetType">
    <ng-container *ngSwitchCase="'SearchFacet'">
      <div class="d-flex">
        <input type="text" class="form-control" [(ngModel)]="searchValue" [placeholder]="facet.label" />
        <button class="btn btn-outline-secondary ml-1" type="button" (click)="onSearch(facet)">></button>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <common-multi-dropdown
        [dropDownItems]="dropdownItems"
        [multiSelectedText]="facet.label"
        [emptyMessage]="facet.label"
        [enableSearch]="true"
        (applyChange)="selectionChanged($event)"
        customClass="bg-white"
      >
      </common-multi-dropdown>
    </ng-container>
  </div>
</div>
